// client/src/lib/legendaryDexNumbers.ts
//
// National-Pokédex numbers of the Legendary class, used by the "Legendary Dex"
// search source (missing legendaries pulled from the main dex). There is no
// complete rarity dataset elsewhere in the app (client/src/lib/pokemon.ts only
// carries flags on a ~120-entry sample), so this is the authoritative list for
// that source.
//
// Scope: Legendary only — Mythicals (Mew, Celebi, Jirachi, Deoxys, the Lake of
// Rage trio's mythics, Arceus, Victini, Keldeo/Meloetta/Genesect, Diancie/Hoopa/
// Volcanion, Magearna/Marshadow/Zeraora/Meltan/Melmetal, Zarude, Pecharunt) and
// Ultra Beasts / Paradox species are intentionally excluded; they have their own
// in-game classifications and filters.

export const LEGENDARY_DEX_NUMBERS: readonly number[] = [
  // Gen 1
  144, 145, 146, 150,
  // Gen 2
  243, 244, 245, 249, 250,
  // Gen 3
  377, 378, 379, 380, 381, 382, 383, 384,
  // Gen 4
  480, 481, 482, 483, 484, 485, 486, 487, 488,
  // Gen 5
  638, 639, 640, 641, 642, 643, 644, 645, 646,
  // Gen 6
  716, 717, 718,
  // Gen 7 (incl. Type: Null / Silvally, Tapus, Cosmog line, Necrozma)
  772, 773, 785, 786, 787, 788, 789, 790, 791, 792, 800,
  // Gen 8 (incl. Kubfu/Urshifu, Galar Regis, Calyrex line, Enamorus)
  888, 889, 890, 891, 892, 894, 895, 896, 897, 898, 905,
  // Gen 9 (Treasures of Ruin, box legends, Loyal Three, Ogerpon, Terapagos)
  1001, 1002, 1003, 1004, 1007, 1008, 1014, 1015, 1016, 1017, 1024,
];

const LEGENDARY_SET = new Set<number>(LEGENDARY_DEX_NUMBERS);

/** True if the given national-dex number is a Legendary species. */
export function isLegendaryDex(dexNumber: number): boolean {
  return LEGENDARY_SET.has(dexNumber);
}
